(() => {
  const normalizeRoot = (value) => {
    const raw = String(value || '/').trim();
    if (!raw || raw === '/') return '';
    const cleaned = raw.replace(/^\/+|\/+$/g, '');
    return cleaned ? `/${cleaned}` : '';
  };

  const sameRouteForLanguage = (currentRootValue, targetRootValue) => {
    const currentRoot = normalizeRoot(currentRootValue);
    const targetRoot = normalizeRoot(targetRootValue);
    let pathname = window.location.pathname || '/';

    if (currentRoot && (pathname === currentRoot || pathname.startsWith(`${currentRoot}/`))) {
      pathname = pathname.slice(currentRoot.length) || '/';
    }
    pathname = `/${pathname.replace(/^\/+/, '')}`;

    const targetPath = targetRoot
      ? (pathname === '/' ? `${targetRoot}/` : `${targetRoot}${pathname}`)
      : pathname;

    return `${targetPath}${window.location.search || ''}${window.location.hash || ''}`;
  };

  const closeAll = (except = null) => {
    document.querySelectorAll('[data-nubs-language]').forEach((root) => {
      if (root === except) return;
      const menu = root.querySelector('[data-nubs-language-menu]');
      const toggle = root.querySelector('[data-nubs-language-toggle]');
      if (menu) menu.hidden = true;
      toggle?.setAttribute('aria-expanded', 'false');
    });
  };

  const bind = (root) => {
    if (!root || root.dataset.nubsLanguageReady === '1') return;
    root.dataset.nubsLanguageReady = '1';

    const form = root.querySelector('form.nubs-language__form');
    const input = root.querySelector('[data-nubs-language-input]');
    const toggle = root.querySelector('[data-nubs-language-toggle]');
    const menu = root.querySelector('[data-nubs-language-menu]');
    if (!form || !input || !toggle || !menu) return;

    toggle.addEventListener('click', () => {
      const opening = menu.hidden;
      closeAll(root);
      menu.hidden = !opening;
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
    });

    root.querySelectorAll('[data-nubs-language-code]').forEach((button) => {
      button.addEventListener('click', () => {
        const code = String(button.dataset.nubsLanguageCode || '').trim();
        if (!code || code === input.value) {
          closeAll();
          return;
        }

        input.value = code;

        let returnInput = form.querySelector('input[name="return_to"]');
        if (!returnInput) {
          returnInput = document.createElement('input');
          returnInput.type = 'hidden';
          returnInput.name = 'return_to';
          form.append(returnInput);
        }

        returnInput.value = sameRouteForLanguage(
          root.dataset.nubsLanguageCurrentRoot || '/',
          button.dataset.nubsLanguageRoot || '/'
        );

        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    });
  };

  const bindAll = (scope = document) => scope.querySelectorAll?.('[data-nubs-language]').forEach(bind);

  bindAll();
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-nubs-language]')) closeAll();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach((node) => {
    if (node.nodeType !== 1) return;
    if (node.matches?.('[data-nubs-language]')) bind(node);
    bindAll(node);
  }))).observe(document.documentElement, {childList: true, subtree: true});
})();
